<template>
  <div class="container">
    <van-nav-bar
      title="成员管理"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickright"
    >
      <template #right>
        <svg-icon icon-class="create_staff" class="icon" @click="onClickright" />
      </template>
    </van-nav-bar>
    <div class="main">
      <van-field
        v-model="extraParams.name"
        left-icon="search"
        placeholder="搜索"
        class="search"
      />
      <!-- <van-search v-model="extraParams.name" label="搜索" :clearable="false" class="search" placeholder="请输入搜索关键词" /> -->
      <wh-mobile-list ref="listTable" class="staff-list" data-src="/api/getStaffList" :extra-params="extraParams">
        <template v-slot="{ list }">
          <div class="list-caption">
            员工列表
          </div>
          <van-cell v-for="item in list" :key="item.id" is-link @click="editStaff(item)">
            <template #title>
              <div class="list-title wh-flex-start">
                <span class="myself">{{ item.name.slice(0, 2) }}</span>
                <span>{{ item.name }}</span>
              </div>
            </template>
            <template #right-icon>
              <van-icon name="arrow" />
            </template>
          </van-cell>
        </template>
      </wh-mobile-list>
    </div>
    <create-staff-popup :visible.sync="staff.visible" :title="staff.title" :init-form-data="staff.form" @submitFormSuccess="submitFormSuccessFn" />
  </div>
</template>
<script>
import createStaffPopup from '@/views/basic/components/createStaffPopup'
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'
export default {
  components: { WhMobileList, createStaffPopup },
  data() {
    return {
      extraParams: {
        fuzzy: 1,
        name: ''
      },
      staff: {
        visible: false,
        title: '新增员工',
        form: {}
      }
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    onClickright() {
      this.staff.visible = true
      this.staff.title = '新增员工'
      this.staff.form = {
        companyId: this.$store.getters.companyId,
        name: '',
        mobile: ''
      }
    },
    editStaff(item) {
      this.staff.visible = true
      this.staff.title = '编辑员工'
      this.staff.form = {
        ...item
      }
    },
    submitFormSuccessFn(flag) {
      if (flag) {
        this.$refs.listTable.onRefresh()
      }
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
/deep/.van-cell::after{
  border-bottom: 1px solid #ccc;
}
.icon{
  color:#41c19e;
  width: 18px;
  height: 18px;
}
.main{
  height: 100%;
  padding: 10px 16px 0;
  box-sizing: border-box;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  .search {
    flex-shrink: 0;
  }
  .staff-list{
    height: 100%;
    margin-top: 20px;
    background-color: #fff;
    .list-caption{
      width: 100%;
      color: #333;
      font-weight: bold;
      font-size: 14px;
      border-bottom: 1px solid #ccc;
      padding: 10px;
    }
    .list-title{
      width: 100%;
      color: #333;
      font-size: 14px;
       span:nth-child(1){
        width: 34px;
        height: 34px;
        background-color: #3e88f1;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        color:#fff;
        margin-right: 6px;
       }
    }
       /deep/ .van-icon-arrow{
         line-height: 34px;
       }
  }
}
</style>
